/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {cancelShiftCover} from '../api'

export const useMutationCancelShiftCover = createReactQueryMutationHook('cancelShiftCover', cancelShiftCover)
